// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Array contains list of on-file wallets and merchants that are registered to accept push provision of input pan and do not already have input pan.  Hence those walletIds are eligible to receive a push provision for this input pan.
 * @export
 * @interface IEligibleOnFileWallet
 */
export interface IEligibleOnFileWallet {
    /**
     * dentifier of button or log asset of wallet, usable in Get Assets API for fetching that asset
     * @type {string}
     * @memberof IEligibleOnFileWallet
     */
    asset_id: string;
    /**
     * The name of the token requester to be displayed to the end user
     * @type {string}
     * @memberof IEligibleOnFileWallet
     */
    consumer_facing_entity_name: string;
    /**
     * Sequence number in list
     * @type {string}
     * @memberof IEligibleOnFileWallet
     */
    sequence_number: string;
    /**
     * Identifier of wallet or merchant that can accept a push provision
     * @type {string}
     * @memberof IEligibleOnFileWallet
     */
    wallet_id: string;
    /**
     * The type of the token requestor WALLET MERCHANT
     * @type {string}
     * @memberof IEligibleOnFileWallet
     */
    wallet_type: string;
    /**
     * Is Issuer Pan Reference Id needed in Push Provision request
     * @type {boolean}
     * @memberof IEligibleOnFileWallet
     */
    issuer_pan_reference_id_needed: boolean;
    /**
     * Is Return URL needed in Push Provision request
     * @type {boolean}
     * @memberof IEligibleOnFileWallet
     */
    return_uri_needed: boolean;
}

/**
 * Check if a given object implements the IEligibleOnFileWallet interface.
 */
export function instanceOfIEligibleOnFileWallet(value: object): value is IEligibleOnFileWallet {
    if (!('asset_id' in value) || value['asset_id'] === undefined) return false;
    if (!('consumer_facing_entity_name' in value) || value['consumer_facing_entity_name'] === undefined) return false;
    if (!('sequence_number' in value) || value['sequence_number'] === undefined) return false;
    if (!('wallet_id' in value) || value['wallet_id'] === undefined) return false;
    if (!('wallet_type' in value) || value['wallet_type'] === undefined) return false;
    if (!('issuer_pan_reference_id_needed' in value) || value['issuer_pan_reference_id_needed'] === undefined) return false;
    if (!('return_uri_needed' in value) || value['return_uri_needed'] === undefined) return false;
    return true;
}

export function IEligibleOnFileWalletFromJSON(json: any): IEligibleOnFileWallet {
    return IEligibleOnFileWalletFromJSONTyped(json, false);
}

export function IEligibleOnFileWalletFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEligibleOnFileWallet {
    if (json == null) {
        return json;
    }
    return {
        
        'asset_id': json['assetId'],
        'consumer_facing_entity_name': json['consumerFacingEntityName'],
        'sequence_number': json['sequenceNumber'],
        'wallet_id': json['walletId'],
        'wallet_type': json['walletType'],
        'issuer_pan_reference_id_needed': json['issuerPanReferenceIdNeeded'],
        'return_uri_needed': json['returnUriNeeded'],
    };
}

export function IEligibleOnFileWalletToJSON(json: any): IEligibleOnFileWallet {
    return IEligibleOnFileWalletToJSONTyped(json, false);
}

export function IEligibleOnFileWalletToJSONTyped(value?: IEligibleOnFileWallet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetId': value['asset_id'],
        'consumerFacingEntityName': value['consumer_facing_entity_name'],
        'sequenceNumber': value['sequence_number'],
        'walletId': value['wallet_id'],
        'walletType': value['wallet_type'],
        'issuerPanReferenceIdNeeded': value['issuer_pan_reference_id_needed'],
        'returnUriNeeded': value['return_uri_needed'],
    };
}

